import React from "react";
import { Helmet } from 'react-helmet-async';
import "../../../assets/styles/ContentMarketing.css";
import contentHero from "../../../assets/images/content.jpg";
import contentStrategy from "../../../assets/images/content.jpg";

const ContentMarketingPage = () => {
    return (
        <div className="content-container">
            <Helmet>
                <title>Content Marketing Services – BuddyTech Solutions</title>
                <meta name="description" content="Engage your audience with impactful content strategies including blogs, articles, infographics, and more." />
                <meta name="keywords" content="content marketing, blog writing, content strategy, copywriting, infographics, digital content" />

                <meta property="og:title" content="Content Marketing Services – BuddyTech Solutions" />
                <meta property="og:description" content="Engage your audience with impactful content strategies including blogs, articles, infographics, and more." />
                <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
                <meta property="og:url" content="https://buddytechsolutions.in/services/marketing/content" />
                <meta property="og:type" content="website" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Content Marketing Services – BuddyTech Solutions" />
                <meta name="twitter:description" content="Engage your audience with impactful content strategies including blogs, articles, infographics, and more." />
                <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
            </Helmet>

            <header className="content-hero">
                <div className="content-hero-content">
                    <h1>Content Marketing Services</h1>
                    <p>
                        Inspire, educate, and convert with compelling digital content that aligns with your brand and drives engagement.
                    </p>
                </div>
                <img src={contentHero} alt="Content Hero" className="content-hero-img" />
            </header>

            <section className="content-section">
                <div className="content-text">
                    <h2>What We Offer</h2>
                    <p>
                        Our content creators deliver meaningful assets that support your campaigns across blogs, web, and social.
                    </p>
                    <ul>
                        <li>Blog Writing & Editing</li>
                        <li>SEO Copywriting</li>
                        <li>Infographics & Visual Content</li>
                        <li>Social Media Content Calendars</li>
                        <li>Content Strategy & Tone Mapping</li>
                    </ul>
                </div>
                <img src={contentStrategy} alt="Content Strategy" className="content-img" />
            </section>

            <section className="content-tools">
                <h2>Tools & Platforms</h2>
                <div className="tools-grid">
                    <span>Grammarly</span>
                    <span>Hemingway</span>
                    <span>Surfer SEO</span>
                    <span>Canva</span>
                    <span>WordPress</span>
                    <span>Jasper</span>
                    <span>Notion</span>
                    <span>Google Docs</span>
                </div>
            </section>
            <section className="contact-options">
                <div className="contact-card email">
                    <h2>📧 Email</h2>
                    <p>Send us an email for inquiries, support or collaboration opportunities.</p>
                    <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
                        Send Email
                    </a>
                </div>

                <div className="contact-card whatsapp">
                    <h2>💬 WhatsApp</h2>
                    <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
                    <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
                        Chat on WhatsApp
                    </a>
                </div>

                <div className="contact-card phone">
                    <h2>📞 Call Us</h2>
                    <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
                    <a href="tel:+919842084312">Call Us</a>
                </div>
            </section>
        </div>
    );
};

export default ContentMarketingPage;
